<template>
  <div id="findpassword">
    <div class="header">
      <div class="inner">
        <router-link :to="{ name: 'Home' }">
          <!-- <img :src='logourl' onerror="src='/static/img/logo.png'" /> -->
          <img
            src="/static/img/logo.png"
            onerror="src='/static/img/logo.png'"
          />
        </router-link>
        <span>您好，欢迎登录{{ $store.state.webInfo.name }}商城！</span>
      </div>
    </div>
    <div
      :style="{
        backgroundImage:
          'url(' +
          ($store.state.webInfo.mall_login_bg == ''
            ? '/static/img/pclogos.jpg'
            : $store.state.webInfo.mall_login_bg) +
          ')',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }"
    >
      <div class="conter">
        <div class="app-container">
          <div class="swiperTitle">
            <span v-if="step === 1" class="active">手机验证</span>
            <span v-if="step === 2" class="active">重置密码</span>
            <span v-if="step === 3" class="active">修改成功</span>
          </div>
          <div class="swiper">
            <swiper
              ref="mySwiper"
              class="swiper-no-swiping"
              :options="swiperOptions"
            >
              <swiper-slide v-if="step === 1">
                <el-form>
                  <el-form-item>
                    <el-input
                      placeholder="请输入已绑定的手机号"
                      v-model="phone"
                    ></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-input
                      placeholder="请输入验证码"
                      v-model="code"
                    ></el-input>
                    <el-button
                      class="phonecode"
                      @click="getNvc('phoneForm')"
                      :loading="codeLoading"
                      >获取验证码</el-button
                    >
                  </el-form-item>
                  <el-form-item style="margin-bottom: 10px; padding-top: 15px">
                    <el-button
                      type="primary"
                      class="g-bottom"
                      style="
                  width:100%;
                    height: 48px;

                    border-radius: 6px;

                  "
                      @click="codeyz"
                      >下一步</el-button
                    >
                  </el-form-item>
                  <!-- <div style="height:62px">
            <el-col :span="11">
              <el-form-item label>
                <el-button type="primary" class="t-btn" @click="codeyz">下一步</el-button>
              </el-form-item>
            </el-col>
          </div> -->
                </el-form>
              </swiper-slide>
              <swiper-slide v-if="step === 2">
                <el-form>
                  <el-form-item>
                    <el-input
                      type="password"
                      placeholder="请输入新密码（密码不少于6个字符"
                      v-model="firstpassword"
                    ></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-input
                      type="password"
                      placeholder="请再次输入密码"
                      v-model="secondpassword"
                    ></el-input>
                  </el-form-item>
                  <el-form-item style="margin-bottom: 10px; padding-top: 15px">
                    <el-button
                      type="primary"
                      class="g-bottom"
                      style="
                  width:100%;
                    height: 48px;

                    border-radius: 6px;

                  "
                      @click="amendpassword"
                      >确认</el-button
                    >
                  </el-form-item>
                  <!-- <div style="height:62px">
            <el-col :span="11">
              <el-form-item label>
                <el-button type="primary" class="t-btn" @click="codeyz">下一步</el-button>
              </el-form-item>
            </el-col>
          </div> -->
                </el-form>
              </swiper-slide>
              <swiper-slide v-if="step === 3">
                <div>
                  <p style="margin-bottom:20px;margin-top:60px;">
                    <img style="width:44px;" src="/static/img/sucess.png" />
                  </p>
                  <div
                    style="height: 32px;font-size: 20px;font-family: MicrosoftYaHei;color: #262626;line-height: 32px;"
                  >
                    密码修改成功！
                  </div>
                  <div
                    style="height: 17px;font-size: 13px;font-family: MicrosoftYaHei;color: #7A7A7A;line-height: 17px;margin-bottom:30px;margin-top:20px"
                  >
                    3S后，页面将自动跳转到登录页面
                  </div>
                  <div>
                    <router-link :to="{ name: 'Login', params: { type: 1 } }">
                      <el-button
                        type="primary"
                        style="width: 168px;height: 40px;background: #E23130;border-radius: 6px;border: 1px solid #E23130;"
                        >返回登录</el-button
                      >
                    </router-link>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-footer style=" background: #ffffff;height:170px;padding:0;">
        <el-footer style=" background: #ffffff;height:183px;padding:0;"
          ><vLoginFooter></vLoginFooter
        ></el-footer>
      </el-footer>
    </div>
    <Nvc ref="nverify" type="nvc_message"></Nvc>
  </div>
</template>
<script>
import Nvc from "@/common/nvc";
import vProcess from "@/common/process";
import vFooter from "@/common/footer";
import vLoginFooter from "@/common/login-footer";
import { swiper, swiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  name: "findpassword",
  data() {
    return {
      step: 1,
      titleArr: ["手机验证", "输入新密码", "完成"],
      phone: "",
      code: "",
      firstpassword: "",
      secondpassword: "",
      phoneCode: "", //验证码id
      codeLoading: false,
      logourl: this.$store.state.webInfo.logo_pc
    };
  },
  components: {
    vProcess,
    vFooter,
    Nvc,
    vLoginFooter,
    swiper,
    swiperSlide
  },
  watch: {
    secondpassword(val) {
      this.secondpassword = this.secondpassword.replace(/\s+/g, "");
    },
    firstpassword(val) {
      this.firstpassword = this.firstpassword.replace(/\s+/g, "");
    }
  },
  methods: {
    getNvc() {
      this.$refs.nverify.toVerify(this.getCode);
    },
    getCode(nvc) {
      //验证 手机号
      if (this.phone == "") {
        this.$alert("请输入手机号码", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      //倒计时
      var _this = this;
      if (this.codeLoading == false) {
        this.$api.get(
          "/message",
          {
            id_example: this.$store.state.id_example,
            phone: this.phone,
            type: 4,
            nvc: nvc
          },
          res => {
            this.$refs.nverify.verifyLater(res.data);
            if (res.data.code == 100) {
              this.phoneCode = res.data.data;
              //短信发送成功开启倒计时
              this.codeLoading = true;
              var time = 60;
              var dd = setInterval(function() {
                time--;
                $(".phonecode").html("倒计时（" + time + "）秒");
                if (time <= 0) {
                  clearInterval(dd);
                  _this.codeLoading = false;
                  $(".phonecode").html(
                    '<span class=\\"van-button__text\\">重新发送</span>'
                  );
                }
              }, 1000);
            } else if (
              res.data.code == "200" ||
              res.data.code == "400" ||
              res.data.code == "600" ||
              res.data.code == "900"
            ) {
              // this.$refs.nverify.verifyLater(res.data);
            } else if (res.data.code == "800") {
              this.$toast("登录次数过多请稍后再试");
            } else {
              this.$alert(res.data.message, "提示", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          }
        );
      }
    },
    //验证验证码
    codeyz() {
      this.$api.post(
        "user/checkCode",
        {
          id_example: this.$store.state.id_example,
          phone: this.phone,
          code: this.phoneCode + "_" + this.code
        },
        res => {
          if (res.data.code == 100) {
            this.step = 2;
          } else {
            this.$alert(res.data.message, "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        }
      );
    },
    amendpassword() {
      if (this.firstpassword != this.secondpassword) {
        this.$alert("请保持2次密码一致", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      this.$api.post(
        "user/resetPwd",
        {
          id_example: this.$store.state.id_example,
          phone: this.phone,
          password: this.firstpassword,
          repassword: this.secondpassword
        },
        res => {
          if (res.data.code == 100) {
            this.step = 3;
            setTimeout(() => {
              this.$router.push({ name: "Login", params: { type: 1 } });
            }, 3000);
          }
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.g-bottom {
  height: 48px;
  background: rgba(226, 49, 48, 1) !important ;
  border-radius: 6px;
  border: 1px solid rgba(226, 49, 48, 1) !important ;
  &:hover {
    background: rgba(226, 49, 48, 0.9) !important ;
    border-radius: 6px;
    border: 1px solid rgba(226, 49, 48, 0.9) !important ;
  }
}
/deep/ .el-input__inner {
  height: 60px;
  line-height: 60px;
  background: #f2f2f2;
  border-radius: 3px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(38, 38, 38, 0.5);
}
.app-container {
  box-shadow: 0px 12px 12px 0px rgba(38, 38, 38, 0.1);
  filter: blur(0px);
  width: 424px;
  background-size: 100%;
  background-color: #fff;
  position: absolute;
  top: 80px;
  right: 20px;
  height: 510px;
  padding: 16px 30px;
  box-sizing: border-box;
  .swiperTitle {
    text-align: left;
    margin-bottom: 60px;

    span {
      position: relative;
      font-size: 16px;
      display: inline-block;
      color: rgba(38, 38, 38, 0.5);
      line-height: 24px;
      margin-right: 30px;
      padding-bottom: 5px;
    }
    .active {
      color: #262626;
    }
    .active::after {
      display: inline-block;
      content: "";
      width: 100%;
      height: 4px;
      border-radius: 3px;
      background: #e23130;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  .phonecode {
    width: 100px;
    position: absolute;
    right: 0px;
    top: 0px;
    height: 60px;
    background: none !important;
    border: none !important;
    color: #e23130;
  }
  .phonecode :hover,
  .phonecode :focus,
  .phonecode :active {
    color: #e23130 !important;
  }
}

.header {
  background: #ffffff !important;
  box-shadow: 0px -7px 13px 0px rgba(110, 110, 110, 0.1);
  .inner {
    width: 1200px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin: auto;
    line-height: 57px;
    display: flex;
    justify-content: space-between;
  }
  height: 80px !important;
  background: white;
  text-align: left;
  img {
    vertical-align: bottom;
    width: auto;
    max-height: 60px;
    max-width: 200px;
  }
  span {
    display: inline-block;
    font-size: 16px;
    margin-left: 20px;
    color: rgba(38, 38, 38, 0.5);
  }
  .inner {
    width: 1200px;
    // padding-top: 35px;
    margin: auto;
  }
  height: 104px;
  background: white;
  text-align: left;
  img {
    // margin-top: 36px;
    // width: 138px;
  }
  span {
    display: inline-block;
    font-size: 16px;
    margin-left: 20px;
  }
}
.conter {
  height: 700px;
  position: relative;
  width: 1200px;
  margin: 0 auto;
  .box {
    width: 380px;
    height: 170px;
    margin: 0px auto;
    position: relative;
  }
  .t-btn {
    width: 109px;
  }
  .el-icon-circle-check {
    margin-right: 10px;
  }
}
.yzm {
  width: 90%;
  margin-left: 10%;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/findpassword.vue